module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/infobg_flea.c6b31f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/infobg_flea.jpg
// module id = zNVt
// module chunks = 0